<div class="container">
  <section class="info">
    <img id="cloud" class="cloud-group" src="../../../assets/img/clouds/cloud-group-3.svg" alt="image">
    <div class="main-title_secondary">Поехали в будущее!</div>
    <div class="info-app-container">
      <a href="https://play.google.com/store/apps/details?id=soft.gelios.com.scooter" class="main-app-android">
        <img src="../../../assets/img/app-android.svg" alt="icon">
      </a>
      <a href="https://apps.apple.com/us/app/busyfly/id1488207086?l=ru" class="main-app-iphone">
        <img src="../../../assets/img/app-iphone.svg" alt="icon">
      </a>
    </div>
    <div class="info-img">
      <div id="scooter" class="info-scooters-container">
        <img class="info-scooter-left" src="../../../assets/img/info-scooter-left.svg"
             alt="image">
        <img class="info-scooter-right" src="../../../assets/img/info-scooter-right.svg"
             alt="image">
      </div>
    </div>
  </section>
</div>
